import { z } from 'my-zod'
import { actionPlanTaskModel } from './action-plan-tasks-model'

export const actionPlanTaskUnfinishedSystemView = actionPlanTaskModel.augment({
  email: z.string(),
  outfitterName: z.string(),
  userName: z.string()
})

export type actionPlanTaskUnfinishedSystemView = z.infer<typeof actionPlanTaskUnfinishedSystemView>
